// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_Gen","cls2":"Playlist-cls2_amk Playlist-cls1_Gen"};